module.exports = __webpack_public_path__ + "static/media/checkbox-answer-checked.b29cad7b.svg";